import React from 'react'
import Banner from '../Components/Banner/Banner';
import CoinTable from '../Components/CoinTable';

const Homepage = () => {
  return (
    <>
      <Banner/>
      <CoinTable/>
    </>
  )
}

export default Homepage;
